
import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { Footer } from './Footer';
import { PublicNavbar } from './PublicNavbar';
import { WebsiteStructuredData } from '@/components/structured-data/WebsiteStructuredData';
import { SiteAnalyticsTracker } from '@/components/analytics/SiteAnalyticsTracker';
import { CookieConsentProvider } from '@/contexts/CookieConsentContext';
import { CookieBanner } from '@/components/cookie-consent/CookieBanner';
import { CookiePreferences } from '@/components/cookie-consent/CookiePreferences';
import { ConditionalAdSense } from '@/components/scripts/ConditionalAdSense';
import { ConditionalTravelPayouts } from '@/components/scripts/ConditionalTravelPayouts';

export function PublicLayout() {
  const baseUrl = window.location.origin;
  
  // Social media profiles for the website
  const socialProfiles = [
    'https://twitter.com/trottingtheworld',
    'https://instagram.com/trottingtheworld',
    'https://facebook.com/trottingtheworld',
    'https://pinterest.com/trottingtheworld'
  ];
  
  return (
    <CookieConsentProvider>
      <div className="min-h-screen bg-background flex flex-col">
        {/* Add website structured data */}
        <WebsiteStructuredData 
          baseUrl={baseUrl}
          siteName="Trotting the World"
          description="Expert travel guides, itineraries, and tips for adventure seekers and global explorers."
          logoUrl="/logo.png"
          socialProfiles={socialProfiles}
        />
        
        {/* Add site analytics tracker */}
        <SiteAnalyticsTracker />
        
        {/* Conditional script loaders - only load with user consent */}
        <ConditionalAdSense />
        <ConditionalTravelPayouts />
        
        {/* Cookie consent UI */}
        <CookieBanner />
        <CookiePreferences />
        
        {/* Header - Using PublicNavbar */}
        <PublicNavbar />

        {/* Main content */}
        <main className="container py-10 flex-grow">
          <Outlet />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </CookieConsentProvider>
  );
}
